import * as React from 'react';
import { PanelHeader } from 'js/components';
import { Card, CardBody, CardHeader, CardTitle } from 'reactstrap';

import { UserForm } from 'js/components';

const TeamRouteComponent = ({ user, formState, onSave }) => {
  const handleSave = userProps => {
    onSave(userProps);
  };

  return (
    <div>
      <PanelHeader size="sm" />
      <div className="content">
        <Card>
          <CardHeader>
            <CardTitle tag="h5">Create a user</CardTitle>
          </CardHeader>
          <CardBody>
            <UserForm user={user} state={formState} onSave={handleSave} />
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default TeamRouteComponent;
